module.exports = __webpack_public_path__ + "img/rvdsb-3@2x.52d93a5a.png";